import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, nightOwl, vsDark } from "@code-surfer/themes";
import CodeUseState from "../../../../../../code-examples/1.useState.mdx";
import CodeUseEffect from "../../../../../../code-examples/1.2.useEffect.mdx";
import CodeUseRef from "../../../../../../code-examples/2.useRef.mdx";
import CodeUseRef2 from "../../../../../../code-examples/2.useRef copy.mdx";
import CodeUseCallback from "../../../../../../code-examples/3.useCallback.mdx";
import CodeuseMemo from "../../../../../../code-examples/4.useMemo.mdx";
import CodeuseReducer from "../../../../../../code-examples/5.useReducer.mdx";
import CodeuseContext from "../../../../../../code-examples/6.useContext.mdx";
import CodeuseImperativeHandle from "../../../../../../code-examples/7.useImperativeHandle.mdx";
import CodeuseLayoutEffect from "../../../../../../code-examples/8.useLayoutEffect.mdx";
import CodeuseDebugValue from "../../../../../../code-examples/9.useDebugValue.mdx";
import CodePitFalls from "../../../../../../code-examples/10.pitfalls.mdx";
import { FullScreenCode } from 'mdx-deck';
import { LiveCode } from 'mdx-deck-live-code';
import { Image } from 'mdx-deck';
import React from 'react';
export default {
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  github: github,
  nightOwl: nightOwl,
  vsDark: vsDark,
  CodeUseState: CodeUseState,
  CodeUseEffect: CodeUseEffect,
  CodeUseRef: CodeUseRef,
  CodeUseRef2: CodeUseRef2,
  CodeUseCallback: CodeUseCallback,
  CodeuseMemo: CodeuseMemo,
  CodeuseReducer: CodeuseReducer,
  CodeuseContext: CodeuseContext,
  CodeuseImperativeHandle: CodeuseImperativeHandle,
  CodeuseLayoutEffect: CodeuseLayoutEffect,
  CodeuseDebugValue: CodeuseDebugValue,
  CodePitFalls: CodePitFalls,
  FullScreenCode: FullScreenCode,
  LiveCode: LiveCode,
  Image: Image,
  React: React
};